import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, Table, message } from "antd";
import { connect } from "react-redux";
import { getUserInfo } from "../../utils/redux/reducers/User";
import { ApiManager, Locale } from "../../utils";

const api = ApiManager.getInstance();
const i18n = Locale.getInstance();

function WechatRedPacketTopupList({ user }) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [paused, setPaused] = useState(false);

  const fetchList = useCallback(
    async (nextPage = 1) => {
      if (!user?.token) {
        return;
      }
      setLoading(true);
      try {
        const res = await api.wechatRedPacketTopup.list.run({
          token: user.token,
          query: { count: 20, page: nextPage },
        });
        if (res.result) {
          setRows(Array.isArray(res.data?.data) ? res.data.data : []);
          setTotal(res.data?.total || 0);
          setPaused(!!res.data?.paused);
          setPage(nextPage);
        } else {
          message.warning(res.message);
        }
      } catch (error) {
        message.error(error.message);
      } finally {
        setLoading(false);
      }
    },
    [user],
  );

  useEffect(() => {
    fetchList(1);
  }, [fetchList]);

  const columns = [
    {
      title: i18n.t("wechatRedPacketTopup.amount"),
      dataIndex: "amount_yuan",
      render: (value) => `¥${value}`,
    },
    {
      title: i18n.t("wechatRedPacketTopup.bookedAt"),
      dataIndex: "booked_at",
    },
    {
      title: i18n.t("wechatRedPacketTopup.balance"),
      dataIndex: "balance_yuan",
      render: (value) => (value === null || value === undefined ? "—" : `¥${value}`),
    },
    {
      title: i18n.t("wechatRedPacketTopup.businessType"),
      dataIndex: "business_type",
      render: (value) => value || "—",
    },
    {
      title: i18n.t("wechatRedPacketTopup.fundFlowNo"),
      dataIndex: "fund_flow_no",
    },
    {
      title: i18n.t("wechatRedPacketTopup.mchId"),
      dataIndex: "mch_id",
    },
  ];

  return (
    <div>
      <Alert
        type={paused ? "warning" : "info"}
        showIcon
        style={{ marginBottom: 16 }}
        message={
          paused
            ? i18n.t("wechatRedPacketTopup.pausedHint")
            : i18n.t("wechatRedPacketTopup.syncHint")
        }
      />
      <Button style={{ marginBottom: 16 }} onClick={() => fetchList(page)}>
        {i18n.t("wechatRedPacketTopup.refresh")}
      </Button>
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: page,
          total,
          pageSize: 20,
          onChange: (next) => fetchList(next),
        }}
      />
    </div>
  );
}

export default connect((state) => ({
  user: getUserInfo(state),
}))(WechatRedPacketTopupList);
